import PropTypes from 'prop-types';
import React from 'react';
import { EmptyInteractions } from './EmptyInteractions';

// Placeholder for PAYS-11326
const StructuredInteractionCard = () => (
  <div>Interaction</div>
);

export function StructuredInteractionsList({ interactions }) {
  const hasInteractions = interactions.length > 0;

  return (
    <>
      {hasInteractions ? (
        interactions.map((interaction) => (
          <StructuredInteractionCard key={interaction.id} />
        ))
      ) : (
        <EmptyInteractions />
      )}
    </>
  );
}

StructuredInteractionsList.propTypes = {
  interactions: PropTypes.arrayOf(PropTypes.object),
};

StructuredInteractionsList.defaultProps = {
  interactions: [],
};
